const data = {
    "root": {
        "header": "Root Header Text",
        "nodeSeq " :  "Step_0",
        "question": "Do you prefer to set your own pace or do you want more structured lessons?",
        "imagePath" : "assets/question_imgs/Picture1.jpg",
        "options": [
            {"value" : "step_1A" ,"text" : "I want to make my own plan"},
            {"value" : "step_1B" ,"text" : "I learn better from live instruction"}
        ]
    },
    "step_1A": {
        "header": " step_1A Header Text",
        "question": " I definitely want to do a practice test using pencil and paper",
        "nodeSeq " :  "Step_1",
        "imagePath": "assets/question_imgs/Picture2.jpg",
        "options": [
            {
                "value": "step_1A_A",
                "text": "Using the same format is very important to me"
            },
            {
                "value": "step_1A_B",
                "text": "Nice, but not necessary"
            }
        ]
    },
    "step_1B": {
        "header": "step_1B Header Text",
        "question": "Getting real-time feedback is important to me.",
        "nodeSeq " :  "Step_1",
        "imagePath": "assets/question_imgs/Picture11.jpg",
        "options": [
            {
                "value": "step_1B_A",
                "text": "Definitely."
            },
            {
                "value": "step_1B_B",
                "text": "Eh, not really. "
            }
        ]
    },
    "step_1A_A": {
        "header": " step_1A_A Header Text",
        "question": " Learning about test-taking strategies is my top priority",
        "nodeSeq " :  "Step_2",
        "imagePath": "assets/question_imgs/Picture3.jpg",
        "options": [
            {
                "value": "step_1A_A_A",
                "text": "Practice is more important"
            },
            {
                "value": "step_1A_A_B",
                "text": "You betcha!"
            }
        ]
    },
    "step_1A_B": {
        "header": "step_1A_B Header Text",
        "question": "Daily goals would help keep me accountable",
        "nodeSeq " :  "Step_2",
        "imagePath": "assets/question_imgs/Picture5.jpg",
        "options": [
            {
                "value": "step_1A_A_A_B",
                "text": "Yup!"
            },
            {
                "value": "step_1A_B_B",
                "text": "Probably wouldn’t help"
            }
        ]
    },
    "step_1B_A": {
        "header": "step_1B_A Header Text",
        "question": "Understanding the concepts covered is my main priority.",
        "nodeSeq " :  "Step_2",
        "imagePath": "assets/question_imgs/Picture10.jpg",
        "options": [
            {
                "value": "step_1A_B_B_B",
                "text": "Yes. I want to know how to solve the problem."
            },
            {
                "value": "step_1B_A_B",
                "text": "Not really. "
            }
        ]
    },
    "step_1B_B": {
        "header": "step_1B_B Header Text",
        "question": "I’m under a time crunch.",
        "nodeSeq " :  "Step_2",
        "imagePath": "assets/question_imgs/Picture12.jpg",
        "options": [
            {
                "value": "step_1B_B_A",
                "text": "Nope."
            },
            {
                "value": "step_1B_A",
                "text": "The test I plan to take is right around the corner."
            }
        ]
    },
    
        "step_1A_A_A": {
            "header": "Step_1A_A_A Header Text",
            "nodeSeq ": "Step_3",
            "question": "I think using online games to study would be fun.",
            "imagePath": "assets/question_imgs/Picture7.jpg",
            "options": [
                {
                    "value": "step_1A_A_A_A",
                    "text": "Meh."
                },
                {
                    "value": "step_1A_A_A_B",
                    "text": "Duh!"
                }
            ]
        },
        "step_1A_A_B" : {
            "header": "step_1A_A_B Header Text",
            "nodeSeq ": "Step_3",
            "question": "I study best with a book",
            "imagePath": "assets/question_imgs/Picture4.jpg",
            "options": [
                {
                    "value": "step_1A_A_B_A",
                    "text": "Call me old-fashioned…I love books!"
                },
                {
                    "value": "step_1A_A_A_A",
                    "text": "It depends on my mood. Book or computer work."
                }
            ]
        },
        "step_1A_B_A" : {
            "header": "step_1A_A_A_B_B Header Text",
            "nodeSeq " :  "Step_5",
            "question": "step_1A_A_A_B_B Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/AOP_only_image.png",
            "productLinkText" : "Get ACT Online Prep",
            "productName" : "ACT Online Prep",
            "productLink" : "https://services.act.org/OA_HTML/ibeCCtpItmDspRte.jsp?section=10020&item=2924801&sitex=10020%3A22372%3AUS%20product%20(not%20this%20page%20https%3A//services.act.org/OA_HTML/ibeCZzpHome.jsp?minisite=10020&respid=22372&grp=ACTSTORE",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_A_A Second Option"}
            ]
        },
        "step_1B_A_A" : {
            "header": "step_1B_A_A Header Text",
            "nodeSeq ": "Step_3",
            "question": "step_1B_A_A Question Text",
            "imagePath": "",
            "options": [
                {
                    "value": "step_1B_A_A_A",
                    "text": "First Option"
                },
                {
                    "value": "step_1B_A_A_B",
                    "text": "Second Option"
                }
            ]
        },
        "step_1B_A_B" : {
            "header": "step_1B_A_B Header Text",
            "nodeSeq ": "Step_3",
            "question": "I want access to free practice tests",
            "imagePath": "assets/question_imgs/Picture6.jpg",
            "options": [
                {
                    "value": "step_1A",
                    "text": "Yes, please."
                },
                {
                    "value": "step_1B_B_A",
                    "text": "Not important to my study plan"
                }
            ]
        },
        "step_1B_B_A" : {
            "header": "step_1B_B_A Header Text",
            "nodeSeq ": "Step_3",
            "question": "A visual classroom seems like a cool way to study.",
            "imagePath": "assets/question_imgs/Picture13.jpg",
            "options": [
                {
                    "value": "step_1A_B",
                    "text": "Not my style."
                },
                {
                    "value": "step_1A_B_B_B",
                    "text": "Class from the comfort of home? Yes, please!"
                }
            ]
        },
        "step_1B_B_B" : {
            "header": "step_1B_B_B Header Text",
            "nodeSeq ": "Step_3",
            "question": "step_1B_B_B Question Text",
            "imagePath": "",
            "options": [
                {
                    "value": "step_1B_B_B_A",
                    "text": "First Option"
                },
                {
                    "value": "step_1B_B_B_B",
                    "text": "Second Option"
                }
            ]
        },
        "step_1A_B_B" : {
            "header": "step_1A_B_B Header Text",
            "nodeSeq ": "Step_3",
            "question": "Video is my favorite format to learn from.",
            "imagePath": "assets/question_imgs/Picture9.jpg",
            "options": [
                {
                    "value": "step_1A_A_A_B_A",
                    "text": "Love video, but I prefer more hands-on practice."
                },
                {
                    "value": "step_1A_B_B_B",
                    "text": "Video or bust. "
                }
            ]
        },
        "step_1A_A_A_A": {
            "header": "step_1A_A_A_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_A_A_A Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/prep_pack.png",
            "productName" : "Prep Pack",
            "productLinkText" : "Get ACT Prep Pack",
            "productLink" : "http://www.act.org/content/act/en/products-and-services/the-act/test-preparation/prep-pack.html",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_A_A Second Option"}
            ]
        },
        "step_1A_A_A_B": {
            "header": "step_1A_A_A_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "Test-day tips would be great.",
            "imagePath" : "assets/question_imgs/Picture8.jpg",
            "options": [
                {"value" : "step_1A_A_A_A" ,"text" : " Please!"},
                {"value" : "step_1A_A_A_B_B" ,"text" : " I can find them somewhere else."}
            ]
        },
        "step_1A_A_B_A": {
            "header": "step_1A_A_B_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_A_B_A Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/prep_guide_book.png",
            "productName" : "Prep Guide",
            "productLinkText" : "Get ACT Prep Guide",
            "productLink" : "https://services.act.org/OA_HTML/ibeCCtpItmDspRte.jsp?section=10020&item=3424861&sitex=10020:22372:US&_ga=2.195987881.40404549.1563997441-402631954.1563810415",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_B_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_B_A Second Option"}
            ]
        },
        "step_1A_A_B_B": {
            "header": "step_1A_A_B_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_A_B_B Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/prep_pack.png",
            "productName" : "Prep Pack",
            "productLinkText" : "Get ACT Prep Pack",
            "productLink" : "http://www.act.org/content/act/en/products-and-services/the-act/test-preparation/prep-pack.html",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_B_B First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_B_B Second Option"}
            ]
        },
        "step_1A_B_A_A": {
            "header": "step_1A_B_A_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_B_A_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_B_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_B_A_A Second Option"}
            ]
        },
        "step_1A_B_A_B": {
            "header": "step_1A_B_A_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_B_A_B Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_B_A_BFirst Option"},
                {"value" : "step_1B" ,"text" : "step_1A_B_A_B Second Option"}
            ]
        },
        "step_1B_A_A_A": {
            "header": "step_1B_A_A_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_A_A_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_A_A_A Second Option"}
            ]
        },
        "step_1B_A_A_B": {
            "header": "step_1B_A_A_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_A_A_B Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_A_A_B First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_A_A_B Second Option"}
            ]
        },
        "step_1B_A_B_A": {
            "header": "step_1B_A_B_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_A_B_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_A_B_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_A_B_A Second Option"}
            ]
        },
        "step_1B_A_B_B": {
            "header": "step_1B_A_B_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_A_B_B Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_A_B_B First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_A_B_B Second Option"}
            ]
        },
        "step_1B_B_A_A": {
            "header": "step_1B_B_A_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_B_A_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_B_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_B_A_A Second Option"}
            ]
        },
        "step_1B_B_A_B": {
            "header": "step_1B_B_A_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_B_A_B Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_B_A_B Option"},
                {"value" : "step_1B" ,"text" : "step_1B_B_A_B Option"}
            ]
        },
        "step_1B_B_B_A": {
            "header": "step_1B_B_B_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_B_B_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_B_B_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_B_B_A Second Option"}
            ]
        },
        "step_1B_B_B_B": {
            "header": "step_1B_B_B_B Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1B_B_B_B Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1B_B_B_B First Option"},
                {"value" : "step_1B" ,"text" : "step_1B_B_B_B Second Option"}
            ]
        },
        "step_1A_B_B_A": {
            "header": "step_1A_B_B_A Header Text",
            "nodeSeq " :  "Step_4",
            "question": "step_1A_B_B_A Question Text",
            "imagePath" : "",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_B_B_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_B_B_A Second Option"}
            ]
        },
        "step_1A_B_B_B" : {
            "header": "step_1A_A_A_B_B Header Text",
            "nodeSeq " :  "Step_5",
            "question": "step_1A_A_A_B_B Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/Rapid_Review.png",
            "productName" : "Rapid Review",
            "productLinkText" : "Get ACT Rapid Review",
            "productLink" : "https://www.kaptest.com/act/partner/act-test-prep",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_A_A Second Option"}
            ]
        },
        
        "step_1A_A_A_B_A" :{
            "header": "step_1A_A_A_B_B Header Text",
            "nodeSeq " :  "Step_5",
            "question": "step_1A_A_A_B_B Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/AOP_only_image.png",
            "productLinkText" : "Get ACT Online Prep",
            "productName" : "ACT Online Prep",
            "productLink" : "https://services.act.org/OA_HTML/ibeCCtpItmDspRte.jsp?section=10020&item=2924801&sitex=10020%3A22372%3AUS%20product%20(not%20this%20page%20https%3A//services.act.org/OA_HTML/ibeCZzpHome.jsp?minisite=10020&respid=22372&grp=ACTSTORE",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_A_A Second Option"}
            ]
        },
        "step_1A_A_A_B_B": {
            "header": "step_1A_A_A_B_B Header Text",
            "nodeSeq " :  "Step_5",
            "question": "step_1A_A_A_B_B Question Text",
            "imagePath" : "",
            "lastNode": true,
            "lastNodeImagePath" : "/assets/AOP_only_image.png",
            "productLinkText" : "Get ACT Online Prep",
            "productName" : "ACT Online Prep",
            "productLink" : "https://services.act.org/OA_HTML/ibeCCtpItmDspRte.jsp?section=10020&item=2924801&sitex=10020%3A22372%3AUS%20product%20(not%20this%20page%20https%3A//services.act.org/OA_HTML/ibeCZzpHome.jsp?minisite=10020&respid=22372&grp=ACTSTORE",
            "options": [
                {"value" : "step_1A" ,"text" : "step_1A_A_A_A First Option"},
                {"value" : "step_1B" ,"text" : "step_1A_A_A_A Second Option"}
            ]
        },
        
        
    
}

export default data